"use client";

import { c as _c } from "react/compiler-runtime";
import { ContentBlockServer } from "@local/ui/src/ContentBlockServer";
import { HeaderMenuMobileButton } from "./Menu/MenuMobile";
import { SearchButton } from "./SearchButton";
import { CartButton } from "./CartButton";
import { useCartSelector, selectItemCount } from "@local/cart/src/cart";
import { useCallback, useMemo, useRef, useState, type ReactNode } from "react";
import { useCartLayout } from "../../../lib/useCartLayout";
import dynamic from "next/dynamic";
import { cn } from "@local/utils/src/cn";
import { getT } from "@local/i18n/src/t";
import { getLanguageForMarket } from "@local/i18n/src/languages";
import { a11y } from "@local/i18n/src/catalogs/a11y";
import { useHydrated } from "@local/utils/src/useHydrated";
const SearchWrapper = dynamic(() => import("@local/search/src/components/Search/Wrapper").then(mod => mod.SearchWrapper), {
  ssr: false
});
interface TopNavigationBarClientProps {
  noNavigation: boolean;
  noCart: boolean;
  noSearch: boolean;
  showCta: boolean;
  market: string;
  className?: string;
  logo: ReactNode;
  navigation: ReactNode;
  cta: ReactNode;
  /**
   * Slot for an account entry point (e.g. @local/identity's AccountButton).
   * A slot rather than a direct import: @local/tracking and @local/webmcp
   * depend on @local/offer, so offer importing @local/identity (which uses
   * both) would create workspace cycles.
   */
  account?: ReactNode;
}
export const TopNavigationBarClient = t0 => {
  const $ = _c(25);
  const {
    noNavigation,
    noCart,
    noSearch,
    showCta,
    market,
    className,
    logo,
    navigation,
    cta,
    account
  } = t0;
  const t = getT(getLanguageForMarket(market), {
    a11y
  });
  const itemCount = useCartSelector(market, "store", selectItemCount);
  const {
    toggleOpen: toggleCart,
    isOpen: isCartOpen
  } = useCartLayout();
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const searchTriggerRef = useRef(null);
  const hydrated = useHydrated();
  const count = hydrated ? itemCount ?? 0 : 0;
  const hideNavigation = noNavigation || isSearchOpen;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsSearchOpen(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const closeSearch = t1;
  const T0 = ContentBlockServer;
  const t2 = "bg-gray-950";
  const t3 = "flex h-[64px] flex-row items-center justify-center md:h-[60px]";
  let t4;
  if ($[1] !== className) {
    t4 = cn("container px-4 xl:px-16", className);
    $[1] = className;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = "flex w-full flex-row items-center justify-between gap-6 text-white xl:gap-4";
  let t6;
  if ($[3] !== hideNavigation) {
    t6 = !hideNavigation && <div className="flex-shrink-0 xl:hidden"><HeaderMenuMobileButton /></div>;
    $[3] = hideNavigation;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== logo) {
    t7 = <div className="flex items-center pt-1.5">{logo}</div>;
    $[5] = logo;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = !hideNavigation && navigation;
  let t9;
  if ($[7] !== t7 || $[8] !== t8) {
    t9 = <div className="flex h-full flex-1 flex-row items-center justify-center gap-6 xl:flex-none xl:justify-start">{t7}{t8}</div>;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = (!noSearch || !noCart || showCta || !!account) && <div className="flex flex-shrink-0 flex-row items-center gap-6 xl:gap-2">{!noSearch && !hideNavigation && <SearchButton ref={searchTriggerRef} ariaLabel={t("a11y.search")} onClick={() => setIsSearchOpen(true)} className={account ? "flex min-h-11 min-w-11 items-center justify-center p-0" : undefined} iconClassName={account ? "h-5 w-5" : undefined} />}{!isSearchOpen && account}{!noCart && !isSearchOpen && <CartButton count={count} ready={hydrated} market={market} onClick={() => toggleCart(!isCartOpen)} className={account ? "aspect-auto h-auto min-h-11 min-w-11 sm:mr-0 md:mr-0" : undefined} />}{cta}</div>;
  let t11;
  if ($[10] !== t10 || $[11] !== t6 || $[12] !== t9) {
    t11 = <div className={t5}>{t6}{t9}{t10}</div>;
    $[10] = t10;
    $[11] = t6;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== T0 || $[15] !== t11 || $[16] !== t4) {
    t12 = <T0 fullWidthBgColor={t2} className={t3} contentClassName={t4}>{t11}</T0>;
    $[14] = T0;
    $[15] = t11;
    $[16] = t4;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== closeSearch || $[19] !== isSearchOpen || $[20] !== market) {
    t13 = <SearchWrapper isOpen={isSearchOpen} onClose={closeSearch} market={market} triggerRef={searchTriggerRef} />;
    $[18] = closeSearch;
    $[19] = isSearchOpen;
    $[20] = market;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t12 || $[23] !== t13) {
    t14 = <>{t12}{t13}</>;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
};